import React from 'react';
import { FiSearch, FiFilter } from 'react-icons/fi';
import EmailListItem from './EmailListItem';

const FOLDER_LABEL = {
  INBOX: 'messages',
  SENT: 'sent',
  DRAFT: 'drafts',
  TRASH: 'messages',
};

const EmailList = ({ messages, loading, selectedId, onSelect, activeFolder }) => {
  const [search, setSearch] = React.useState('');

  const filtered = search.trim()
    ? messages.filter(
        (m) =>
          m.subject?.toLowerCase().includes(search.toLowerCase()) ||
          m.from?.name?.toLowerCase().includes(search.toLowerCase()) ||
          m.from?.email?.toLowerCase().includes(search.toLowerCase()) ||
          m.snippet?.toLowerCase().includes(search.toLowerCase())
      )
    : messages;

  return (
    <div className="ec-email-list-panel">
      <div className="ec-list-search">
        <div className="ec-search-wrap">
          <FiSearch size={14} />
          <input
            className="ec-search-input"
            placeholder="Search emails..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="ec-list-meta">
        <span>
          {loading ? 'Loading...' : `${filtered.length} ${FOLDER_LABEL[activeFolder] || 'messages'}`}
        </span>
        <button className="ec-filter-btn">
          <FiFilter size={12} /> Filter
        </button>
      </div>

      <div className="ec-messages-list">
        {loading ? (
          <div className="ec-list-loading">
            <div className="ec-spinner" />
            <span>Fetching emails...</span>
          </div>
        ) : filtered.length === 0 ? (
          <div className="ec-list-empty">
            <span style={{ fontSize: 32, opacity: 0.2 }}>✉</span>
            <span>{search ? 'No results found' : 'No emails here'}</span>
          </div>
        ) : (
          filtered.map((m) => (
            <EmailListItem
              key={m.id}
              message={m}
              selected={m.id === selectedId}
              onClick={() => onSelect(m.id)}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default EmailList;
